
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.707 8.003l.139.16c.326.37.804.865 1.405 1.358C4.466 10.518 6.114 11.45 8 11.45c.088 0 .175-.002.262-.006l1.332 1.332A7.444 7.444 0 018 12.95c-2.38 0-4.357-1.167-5.7-2.269A13.73 13.73 0 01.296 8.645a7.662 7.662 0 01-.113-.147l-.044-.06a.75.75 0 010-.87l.044-.06a11.658 11.658 0 01.537-.656c.35-.4.856-.925 1.493-1.457L3.28 6.461l-.028.023a12.23 12.23 0 00-1.544 1.519zM12.75 9.521a12.226 12.226 0 001.543-1.518l-.139-.16c-.326-.371-.804-.866-1.405-1.36C11.534 5.488 9.886 4.556 8 4.556c-.086 0-.172.002-.257.006L6.41 3.228A7.446 7.446 0 018 3.055c2.38 0 4.357 1.167 5.7 2.269a13.727 13.727 0 012.004 2.036c.049.062.087.112.113.147l.044.06a.75.75 0 010 .87l-.044.06a11.633 11.633 0 01-.537.656c-.35.399-.855.923-1.49 1.454l-1.066-1.065.025-.02z"}}),_c('path',{attrs:{"d":"M7.43 10.613A2.675 2.675 0 015.39 8.567l2.042 2.046zM8.576 5.394a2.675 2.675 0 012.033 2.033L8.576 5.394z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M.22.22a.75.75 0 011.06 0l14.5 14.5a.75.75 0 11-1.06 1.06L.22 1.28a.75.75 0 010-1.06z"}})])
          )
        }
      }
    